import { lazy, Suspense } from 'react';
import { SAMPLE_ARCS } from './globeData';
import type { GlobeConfig } from './globeData';

// three-globe 体积较大，延迟加载
const World = lazy(() => import('./World').then((m) => ({ default: m.World })));

export function GlobeBackground({
  className = '',
  globeConfig,
}: {
  className?: string;
  globeConfig?: Partial<GlobeConfig>;
}) {
  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`}>
      <Suspense fallback={null}>
        <World data={SAMPLE_ARCS} globeConfig={globeConfig} />
      </Suspense>
    </div>
  );
}
